<div class="flex gap-md">
  <div class="flex flex-col gap-md">
    <p class="reset-p font-bold">{{ 'Before you proceed' | translate }}</p>

    <p
      class="reset-p"
      [innerHTML]="
        'Here’s important information before you schedule your downgrade to [message].'
          | translate: { message: confirmDowngradeSubtitleMessage | bold }
      "
    ></p>

    <ul class="m-0 pl-lg children:py-sm">
      <li
        [innerHTML]="
          'Your current plan will remain active until [date].'
            | translate
              : {
                  date: nextBillingDate | localeDate: 'long' | bold,
                }
        "
      ></li>
      <li>
        {{
          'You can cancel this scheduled downgrade anytime before [date].'
            | translate
              : {
                  date: nextBillingDate | localeDate: 'long',
                }
        }}
      </li>
      @if (currentSubscription()?.scheduled_subscription) {
        <li>
          {{
            'Making this change to your subscription, overrides and cancels your already scheduled downgrade.'
              | translate
          }}
        </li>
      }
    </ul>
  </div>

  @if (overQuota) {
    <sb-dialog-sidebar>
      <sb-dialog-block [header]="'You\'ll have to say goodbye to' | translate">
        <ul class="reset-ul flex list-none flex-col gap-sm">
          @for (quota of quotaReached; track $index) {
            <li class="flex items-center gap-sm">
              <sb-icon [name]="'times-circle'" class="text-support"></sb-icon>
              {{ quota.limit > 0 ? (quota.usage - quota.limit + ' ' + quota.name | lowercase) : quota.name }}
            </li>
          }
        </ul>
      </sb-dialog-block>
    </sb-dialog-sidebar>
  }
</div>
<div class="flex justify-end gap-sm p-md">
  <button sb-button [color]="'secondary'" (click)="cancelClick.emit()">{{ 'Cancel' | translate }}</button>
  <button sb-button [color]="'primary'" [sbLadda]="isLoading()" (click)="confirmClick.emit()">
    {{ 'Downgrade' | translate }}
  </button>
</div>
